// 25.01.19 - The HomeComponent displays the table of cases we have and also fetches the cases as soon as its mounted. Error handling added. Force error line 99.
import * as React from "react";
import { CaseFormType, UserRoles } from "../../constants/api";
import { withStyles } from "@material-ui/core";
import { history } from "src/store/config";
import { generalStyles } from "src/styles/general";
import { Loading } from "../common/loading_component";
import KendoGrid from "./grid";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import ClearFilterIcon from "@material-ui/icons/DeleteSweep";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import { Loader } from "../common/loader.component";
import { Toaster } from "../common/toaster.component";

// 23.01. Error handling added
class HomeComponent extends React.Component<any, any> {
  private kendoGrid: any;

  constructor(props: any) {
    super(props);
    this.state = {
      error: false,
      info: null,
      filterSwitch: false,
      gridData: [],
      isGridDataRequestSent: false,
      issueTypeFilter: [],
      requestTypeFilter: [],
      claimStatusFilter: [],
      claimTypeFilter: [],
      isGridFilterReset: false,
    };

    this.kendoGrid = React.createRef();
  }

  private updateGridFilterResetState = () => {
    this.setState({ isGridFilterReset: false });
  }

  // 23.01. Error handling added
  public componentDidCatch(error: any, info: any) {
    // Something happened to one of my children. Add error to state
    this.setState({
      error,
      info,
    });
  }

  public render() {
    const { filterSwitch, gridData } = this.state;
    const lblFilter = filterSwitch ? "Hide Filter" : "Show Filter";
    const {
      showNoDataMessage,
      currentUser,
      closeToaster,
      toasterMessage,
      isToasterVisible,
      isSuccessMessage,
      isLoaderVisible,
    } = this.props;
    // 25.01. Q3 This is an example on conditional rendering.
    // if (this.props.caseData === undefined) {
    if (showNoDataMessage) {
      return <h1>Currently no data available to display</h1>;
    } else if (gridData.length === 0) {
      return (
        // <h1>Currently no data available to display</h1>
        <Loading />
      );
    } else {
      if (this.state.error) {
        return (
          <div>
            <h1>Oops!!! Something went wrong</h1>
            <p>
              Please contact{" "}
              <a href="emailto:sd.complaints@unicef.org ">
                UNICEF Supply Division
              </a>
            </p>
            <p>{this.state.error.toString()}</p>
          </div>
        );
      } else {
        return (
          <div>
            <Loader visible={isLoaderVisible} />
            <Toaster
              message={toasterMessage}
              open={isToasterVisible}
              close={closeToaster}
              success={isSuccessMessage}
            />
            <div style={{ marginBottom: "10px" }}>
              <Grid
                container={true}
                direction="row"
                alignItems="center"
                justify="flex-end"
              >
                <Grid item={true}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={filterSwitch}
                        onChange={this.handleChange}
                        value="filterSwitch"
                        color="primary"
                      />
                    }
                    label={lblFilter}
                  />
                  {filterSwitch ? (
                    <Tooltip title="Clear Filter">
                      <IconButton
                        color="primary"
                        onClick={this.clearGridFilter}
                      >
                        <ClearFilterIcon />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                </Grid>
                {currentUser.roleId === UserRoles.QMU ||
                  currentUser.roleId === UserRoles.INS ? (
                  <React.Fragment>
                    <Grid item={true}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.exportClaim}
                        style={{ marginRight: "10px" }}
                      >
                        Export Claims
                      </Button>
                    </Grid>
                    <Grid item={true}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.exportComplaint}
                        style={{ marginRight: "10px" }}
                      >
                        Export Complaints
                      </Button>
                    </Grid>
                    <Grid item={true}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.exportIncidents}
                      >
                        Export Incidents
                      </Button>
                    </Grid>
                  </React.Fragment>
                ) : null}
              </Grid>
            </div>
            <div>{this.renderGrid()}</div>
          </div>
        );
      }
    }
  }

  public componentDidMount() {
    if (this.props.currentUser && this.props.allowFetchGridData) {
      this.props.getGridData(
        this.props.currentUser.roleId.toString(),
        this.props.currentUser.userName
      );

      this.setState({ isGridDataRequestSent: true });

      if (this.props.currentUser.roleId !== UserRoles.Partner) {
        this.generateIssueTypeFilter();
        this.generateClaimStatusFilter();
        this.generateClaimTypeFilter();
        this.generateRequestTypeFilter();
      }
      return;
    }

    //history.push("/");
  }

  public componentDidUpdate(prevProps: any) {
    if (this.props.currentUser && this.props.allowFetchGridData
      && !this.state.gridData.length && !this.state.isGridDataRequestSent) {

      this.props.getGridData(
        this.props.currentUser.roleId.toString(),
        this.props.currentUser.userName
      );

      this.setState({ isGridDataRequestSent: true });
    }

    if (prevProps.gridData !== this.props.gridData) {
      this.setState({
        gridData: this.props.gridData,
      });
    }

    if (
      prevProps.allowFetchGridData !== this.props.allowFetchGridData &&
      this.props.allowFetchGridData
    ) {
      this.props.getGridData(
        this.props.currentUser.roleId.toString(),
        this.props.currentUser.userName
      );
    }
  }

  private exportClaim = () => {
    const { exportClaim } = this.props;
    exportClaim();
  };

  private exportComplaint = () => {
    const { exportComplaint } = this.props;
    exportComplaint();
  };

  private exportIncidents = () => {
    const { exportIncidents } = this.props;
    exportIncidents();
  };

  private renderGrid = () => {
    const { gridData } = this.state;
    // const { selectCase } = this.props;
    const tableData: any = gridData;
    const {
      filterSwitch,
      issueTypeFilter,
      claimStatusFilter,
      claimTypeFilter,
      requestTypeFilter
    } = this.state;
    return (
      <KendoGrid
        gridData={tableData}
        countries={this.props.countries}
        showFilter={filterSwitch}
        ref={this.kendoGrid}
        selectCase={this.props.selectCase}
        issueTypeFilter={issueTypeFilter}
        claimStatusFilter={claimStatusFilter}
        claimTypeFilter={claimTypeFilter}
        requestTypeFilter={requestTypeFilter}
        currentUser={this.props.currentUser}
        updateGridFilterResetState={this.updateGridFilterResetState}
        isGridFilterReset={this.state.isGridFilterReset}
      />
    );
  };

  private handleChange = (event: any) => {
    this.setState({ filterSwitch: event.target.checked });
  };

  private clearGridFilter = () => {
    this.kendoGrid.current.resetFilter();
    this.setState({ isGridFilterReset: true });
  };

  // This method is used to format issue type data which will be used in Grid for filltering purpose.
  private generateIssueTypeFilter = () => {
    const { issueTypes } = this.props;
    const issueTypeFilter = issueTypes.map((value: any) => value.name);
    this.setState({
      issueTypeFilter,
    });
  };

  private generateRequestTypeFilter = () => {
    this.setState({
      requestTypeFilter: [
        { text: "Select Type", value: "" },
        { text: "Standard", value: CaseFormType.Standard },
        { text: "Incident", value: CaseFormType.Incident },
        { text: "Warehouse Nonconformity", value: CaseFormType.WarehouseNonConformity }
      ],
    });
  };

  // This method is used to format claim status data which will be used in Grid for filltering purpose.
  private generateClaimStatusFilter = () => {
    const { claimStatus } = this.props;
    const claimStatusFilter = claimStatus.map((value: any) => value.name);
    this.setState({
      claimStatusFilter,
    });
  };

  // This method is used to format claim type data which will be used in Grid for filltering purpose.
  private generateClaimTypeFilter = () => {
    const { claimTypes } = this.props;
    const claimTypeFilter = claimTypes.map((value: any) => value.name);
    this.setState({
      claimTypeFilter,
    });
  };
}

export default withStyles(generalStyles)(HomeComponent);
